// Shared clipboard helper for every "copy referral code/link" surface (the
// referral CTA hook, the rewards page, and the hero carousel all need the same
// safety net, so it lives in one place instead of being copy-pasted three ways).

/**
 * Best-effort clipboard write. Never leaves a rejected promise unhandled —
 * NotAllowedError (denied permission, insecure context, blocked by browser
 * policy) is expected here, not a bug, so it must not reach Sentry as an
 * unhandled rejection. Falls back to the deprecated execCommand path since
 * some in-app/embedded browsers reject the async Clipboard API outright but
 * still support it.
 */
export async function writeToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through to the legacy fallback below
  }
  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}
